module.exports = __webpack_public_path__ + "static/media/apostilage.8eaa62ca.jpg";